// extracted by mini-css-extract-plugin
export default {"wrapper":"TC-z","viewport":"UC-z","container":"VC-z","slide":"WC-z"};